import { IUnifiedWidgetUsecase } from '@/types/unifiedExpandWidgets'

export const CYS_WIDGET_HEIGHT = 180
export const CYS_MAX_CARDS = 3
// Same banner height for guest and signed-in so the expand clip does not crop the strip.
export const ELITE_BANNER_HEIGHT_PX = 114
export const WIDGET_MARGIN_HEIGHT = 40
// Space between CYS and Elite; also clears the calendar that hangs above the banner.
export const WIDGET_STACK_GAP_PX = 20

export const AIR_FUNNEL_JOURNEY_TYPE = 'AIR_FUNNEL_JOURNEY'
export const AIR_LOYALTY_USECASE = 'AIR_LOYALTY'

export const WIDGET_TO_USECASE: Record<string, IUnifiedWidgetUsecase> = {
    cys: AIR_FUNNEL_JOURNEY_TYPE,
    loyalty: AIR_LOYALTY_USECASE
}
